module.exports = __webpack_public_path__ + "img/ico_menu--white.667f4392.svg";